<template>
	<b-list-group-item class="py-2 px-1 px-lg-2">
		<!-- 
							
							question row
							
		-->
		<div
			class="d-flex flex-column flex-sm-column flex-md-row justify-content-between align-items-center"
		>
			<!-- question title-->
			<div :title="question.description" class="order-1 order-sm-1">
				<span class="py-2 text-info text-shadow">{{ question.title }}&nbsp;</span>
				<!-- reset button answer -->
				<b-button
					v-show="selectedAnswer && !isParentCompleted"
					@click="resetAnswer()"
					variant="outline-secondary"
					class="border-0 py-0 align-text-top"
					title="reset answer"
				>
					<font-awesome-icon size="xs" :icon="['fas', 'undo']" />
				</b-button>
			</div>

			<!-- answers container  -->
			<b-form-group class="flex-grow-1 order-3 order-sm-3 order-md-2 ml-0 ml-md-auto my-0">
				<!-- <b-form-radio-group size="sm" v-model="form.selected" buttons :button-variant="answersColors"> -->
				<b-form-radio-group v-model="form.selected" class="text-left text-md-right">
					<!-- answers  -->

					<b-form-radio
						v-for="answer in question.answers"
						:key="answer.id + question.id"
						:title="answer.description"
						:value="answer.id"
						@change="valueChanged('selected', answer.id)"
						:class="answersColors"
					>
						<span class="answer-title">{{ answer.title }}</span>
					</b-form-radio>
				</b-form-radio-group>
			</b-form-group>

			<!-- show-hide comment field buttons -->
			<div class="order-2 order-sm-2 order-md-3 my-0">
				<b-button
					v-if="!showCommentField"
					@click.prevent="collapseComment()"
					variant="outline-secondary"
					size="sm"
					class="border-0"
				>
					<font-awesome-icon :icon="['fas', 'comment']" />
				</b-button>

				<b-button
					v-else-if="showCommentField"
					@click.prevent="valueChanged('comment', '')"
					variant="outline-success"
					size="sm"
					class="border-0"
				>
					<font-awesome-icon :icon="['fas', 'comment']" />
				</b-button>
			</div>
		</div>
		<!-- 
							
							collapse comment field 
							
		-->
		<transitionExpand :duration="100">
			<b-row v-show="showCommentField">
				<b-col offset-xl="3" class="mt-2">
					<!-- <b-form-input
						class="comment-input border-0 bg-light rounded"
						size="sm"
						v-model="form.comment"
						debounce="500"
						@update="valueChanged('comment', ...arguments)"
					></b-form-input>-->
					<b-form-textarea
						@update="valueChanged('comment', ...arguments)"
						max-rows="5"
						rows="2"
						size="sm"
						class="mb-1 comment-input border-0 bg-light rounded"
						v-model="form.comment"
						debounce="500"
					></b-form-textarea>
				</b-col>
			</b-row>
		</transitionExpand>
	</b-list-group-item>
</template>

<script>
	import transitionExpand from "@/components/utils/TransitionExpand.vue";

	export default {
		name: "QuestionAndAnswer",

		components: { transitionExpand },

		// props to be passed to this component
		props: {
			// whole question
			question: {
				type: Object
			},

			// is the parent AP locked (is not writable)
			isParentCompleted: {
				type: Boolean,
				default: false
			}
		},

		// data
		data() {
			return {
				form: {
					selected:
						this.question.result == null ? "" : this.question.result.answer_id,
					comment:
						this.question.result == null ? "" : this.question.result.comment
				},
				collapseCommentField: false
				// collapseCommentField: Math.random() >= 0.5
			};
		},

		computed: {
			// should the comment field be shown
			showCommentField() {
				return (
					this.collapseCommentField ||
					(this.form.comment != null && this.form.comment != "")
				);
			},

			// returns selected answer object
			selectedAnswer() {
				return this.question.answers.find(item => item.id === this.form.selected);
			},

			// class to color answer buttons according to answer.feels
			answersColors() {
				return !this.form.selected
					? ""
					: this.selectedAnswer["feels"] === 0
					? "negative"
					: "positive";
			}
		},

		// the selected answer has been changed
		methods: {
			valueChanged: function(field, val) {
				this.form[field] = val;

				// var item = this.question.answers.find(item => item.id === val);

				// if it has been clicked on the comment button
				if (field == "comment") {
					this.collapseCommentField = val != "";
				}

				// pass it to parent (id of the choosed answer, and comment if any)
				this.$emit("answerChanged", this.form.selected, this.form.comment);
			},

			// reset answer to null
			resetAnswer() {
				this.form.selected = null;
				this.$emit("answerChanged", null, this.form.comment);
			},

			// just show comment field
			collapseComment() {
				this.collapseCommentField = true;
			}
		}
	};
</script>

<style>
</style>